(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningItemEditDownloadableTab", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/learningItems/edit/learningItemType/learningItemEditDownloadableTabView.html",
            controller: ["learningItemFilesResource", "Upload", "messageService", "$scope", "$timeout", "_", "$uibModal", LearningItemEditDownloadableTabCtrl],
            controllerAs: "vm"
        };
        function LearningItemEditDownloadableTabCtrl(learningItemFilesResource, Upload, messageService, $scope, $timeout, _, $uibModal) {
            var vm = this;
            vm.isEditable = true;
            vm.invalidFiles = [];
            $scope.$parent.vm.learningItemResourceObject.$promise.then(function () {
                vm.learningItem = $scope.$parent.vm.learningItem;
                if (vm.learningItem.completionCount > 0)
                    vm.isEditable = false;
            }).catch(angular.noop);
            vm.getLearningItemDownloadable = function (id) {
                return _.find(vm.learningItem.learningItemFiles, { localizationId: id });
            };
            vm.acceptedFileTypes = ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.wmv,.mp4,.png,.gif,.jpg,.tif,.txt";
            vm.upload = function (files, errFiles, learningItemDownloadable, localization) {
                vm.uploadResult = {};
                vm.localizationId = localization.id;
                vm.localizationCulture = localization.languageCulture;
                if (files && files.length) {
                    vm.uploadResult = Upload.upload({
                        url: "api/learningItemFiles/" + vm.learningItem.code + "/" + vm.localizationCulture + "/multiple",
                        data: { files: files }
                    });
                    vm.uploadResult.then(function (response) {
                        $timeout(function () {
                            vm.learningItem.learningItemFiles = _.union(vm.learningItem.learningItemFiles, response.data);
                            reloadLocalizationRepeater();
                            //Multi-Files
                            messageService.success("common.dropzone.uploadedFileMessage");
                            vm.fileUploadProgressValue = 0;
                            $scope.$apply();
                        });
                    }, function (response) {
                        if (response.status > 0) {
                            var error = response.data.exceptionMessage ? response.data.exceptionMessage : response.data.message;
                            messageService.error(error);
                        }
                        vm.fileUploadProgressValue = 0;
                    }, function (evt) {
                        vm.fileUploadProgressValue = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                    });
                }
            };
            function reloadLocalizationRepeater() {
                vm.learningItem.enabledLocalizations = angular.copy(vm.learningItem.enabledLocalizations);
            }
            vm.removeFile = function (fileUrl) {
                $scope.$parent.vm.formData.specificInfo.files = _.without($scope.$parent.vm.formData.specificInfo.files, _.find($scope.$parent.vm.formData.specificInfo.files, { fileUrl: fileUrl }));
                $scope.$parent.vm.form.$valid = $scope.$parent.vm.formData.specificInfo.files.length > 0;
                vm.invalidFiles = [];
            };
            vm.deleteFile = function (file) {
                var modal = $uibModal.open({
                    templateUrl: "deleteDownloadableFileConfirmation.html",
                    backdrop: false,
                    animation: false,
                    windowClass: "confirmation-modal"
                });
                modal.result.then(function () {
                    learningItemFilesResource.deleteFile({ code: vm.learningItem.code, id: file.id }, function () {
                        vm.learningItem.learningItemFiles = _.without(vm.learningItem.learningItemFiles, file);
                        reloadLocalizationRepeater();
                    }, function (error) {
                        messageService.error(error);
                    });
                }).catch(angular.noop);
            };
            vm.replaceFile = function (file, errFiles, learningItemDownload, localization, originalFile) {
                if (file && vm.invalidFiles.length === 0) {
                    var modal = $uibModal.open({
                        templateUrl: "replaceDownloadableFileConfirmation.html",
                        backdrop: false,
                        animation: false,
                        windowClass: "confirmation-modal"
                    });
                    modal.result.then(function () {
                        vm.file = file;
                        vm.localizationId = localization.id;
                        vm.localizationCulture = localization.languageCulture;
                        if (errFiles.length > 0) {
                            vm.file = errFiles[0];
                            if (vm.file.$error === "maxSize")
                                messageService.error("common.dropzone.fileTooBigMessage");
                            else if (vm.file.$error === "pattern")
                                messageService.error("common.dropzone.invalidFileTypeMessage");
                            else
                                messageService.error("common.dropzone.generalErrorMessage");
                            return;
                        }
                        file.upload = Upload.upload({
                            url: "api/learningItemFiles/" + originalFile.id + "/" + vm.learningItem.code + "/" + vm.localizationCulture + "/replace",
                            data: { file: file }
                        });
                        file.upload.then(function (response) {
                            $timeout(function () {
                                var replacedFile = _.find(vm.learningItem.learningItemFiles, originalFile);
                                replacedFile.fileName = response.data.fileName;
                                replacedFile.fileUrl = response.data.fileUrl;
                                messageService.success("common.dropzone.uploadedFileMessage");
                                vm.fileUploadProgressValue = 0;
                            });
                        }, function (response) {
                            if (response.status > 0) {
                                var error = response.data.exceptionMessage ? response.data.exceptionMessage : response.data.message;
                                messageService.error(error);
                            }
                            vm.fileUploadProgressValue = 0;
                        }, function (evt) {
                            vm.fileUploadProgressValue = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                        });
                    }).catch(angular.noop);
                }
            };
            vm.validateSameName = function (file, localization, originalFile) {
                if (originalFile) {
                    if (file.name === originalFile.fileName) {
                        return true;
                    }
                    else {
                        if (_.some(vm.learningItem.learningItemFiles, { fileName: file.name, localizationId: localization.id }))
                            return "sameName";
                        else
                            return true;
                    }
                }
                else {
                    if (_.some(vm.learningItem.learningItemFiles, { fileName: file.name, localizationId: localization.id }))
                        return "sameName";
                    else
                        return true;
                }
            };
            vm.checkIsEditable = function (localizationId) {
                return !_.some(vm.learningItem.learningItemFiles, { isDownloaded: true, localizationId: localizationId });
            };
        }
    });
})();
